import {Component, Input} from "@angular/core";

@Component({
    selector: 'app-side-helptext',
    templateUrl: './helptext.side.component.html',
    standalone: false
})
export class HelptextSideComponent {
  @Input() textkey: string;

  @Input() viewPoint: string = 'medium';

  toggle: boolean = false;
}
